import { defineStore } from 'pinia'

export const useAdjusterToUserDataStore = defineStore('adjusterToUserData', {
  state: () => {
    return {
      url: '',
      createdAt: '',
      firstName: '',
      lastName: '',
      status: false
    }
  },
  actions: {
    setData (data) {
      this.url = data.url;
      this.createdAt = data.createdAt;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.status = data.status;
    },
  }
})
